import axios from "axios";
import config from "./config";

const env = process.env.NODE_ENV || "development";
var stage = config[env];
const API_URL = stage.base_url + "/auth/";

const login = (email, password, loginType) => {
  return axios.post(API_URL + "login", {
    email,
    password,
    loginType: loginType,
  });
};

const logout = (state, setState) => {
  localStorage.removeItem("id_token");
  setState({
    jwt: "",
    user: {},
    loading: false,
  });
};

// const getCurrentUser = () => {
//   return JSON.parse(localStorage.getItem("user"));
// };

export default {
  login,
  logout,
};
